// src/utils/liity/applyJerryApi.js
// POST the operator's Jerry self-application. Throws on non-2xx (caller handles
// 401 → logout, 4xx → surface message). Mirrors valutApi.js philosophy.
import { API_URL } from "src/utils/apiUrl";
import { jsonOrThrow, authHeaders } from "src/utils/apiFetch";

export async function applyJerry({ token, alue, coverageRadiusKm, phone, note }) {
    const res = await fetch(`${API_URL}/api/pumppuRequests/apply-jerry`, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...authHeaders(token) },
        body: JSON.stringify({ alue, coverageRadiusKm, phone, note }),
    });
    return jsonOrThrow(res);
}
